const API = "https://creator-mvp-hvdx.onrender.com";

// 🚀 INITIATE SUPPORT PAYMENT (MATCH BACKEND)
export const initiateSupportPayment = async (payload) => {
  const res = await fetch(`${API}/support/initiate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();
  return data;
};